/* eslint-disable*/
import React, { useState, useContext } from 'react';
import {
  Grid,
  RACModalCard,
  RACButton,
  makeStyles,
  RACTooltip,
} from '@rentacenter/racstrap';
import Typography from '@mui/material/Typography';
import { agreementContext } from '../context/PaymentInformationContext';
import CONSTANTS from '../constants/constant';
import { Customer } from '../interface/paymentInfoInterface';
import { useTranslation } from 'react-i18next';
import { ReactComponent as InfoIcon } from "../../assets/images/info-tooltip.svg"
import { exportPaymentOriginModalStyles } from '../stylesJS/paymentOriginModal';
import { AgreementDetail, PrePifPromoCode, StorePromotion } from '../interface/commonInterface';
import { ReactComponent as AlertIcon } from '../../assets/images/apiErrorIcon.svg'
export interface PaymentOriginModalProps {
  onClose: (onclose: boolean) => void;
}

type ButtonColor = 'inherit' | 'default' | 'secondary' | 'primary';
type ButtonVariant = 'outlined' | 'contained';

export const PaymentOriginModal: React.FC<PaymentOriginModalProps> = ({
  onClose,
}) => {
  const classes = exportPaymentOriginModalStyles();
  const agreementInfo = useContext(agreementContext);
  const { paymentInfo, customerInfo, featureFlags, agreementOptions } = useContext(agreementContext);
  const [activeButton, setActiveButton] = useState<string | null>(null);
  const [showConvenienceFee, setShowConvenienceFee] = useState(false);
  const [loadingSaveYes, setLoadingSaveYes] = useState(false);
  const [loadingStore, setLoadingStore] = useState(false);
  const convienevnceFeeWithoutTax =
    agreementInfo?.customerInfo?.convinenceFee?.[0]?.amount;

  const storeNumber: string | null = sessionStorage.getItem(
    CONSTANTS.STORE_NUMBER
  );

  const customerName: string = (customerInfo?.customerDetails?.[0]?.firstName || '') + " " + (customerInfo.customerDetails?.[0]?.lastName || '')
  const PIFThreshold: number = Number(featureFlags?.PrePIFDaysThreshold)
  const prePifPromoCodes: PrePifPromoCode[] = agreementOptions?.prePifPromoCodes || [];
  const storePromotions: StorePromotion[] = agreementOptions?.storePromotions || [];
  const matchedPromotions: PrePifPromoCode[] = prePifPromoCodes.filter(prePromo =>
    storePromotions.some(storePromo => storePromo.promotionCode === prePromo.promoCode)
  );
  const language = window.sessionStorage.getItem('language')
  const EXCLUDED_AGREEMENT_TYPES: string[] = [
    'PROMO',
    'RENT TO RENT - LOANER',
    'NOTE PAYMENT',
    'PIF NOTE'
  ];

  console.log(customerName, PIFThreshold, matchedPromotions, "customer name and pif and promocodes");

  const delay = (ms: number) =>
    new Promise((resolve) => setTimeout(resolve, ms));

  const handleCloseClick = async (inStore?: string) => {
    if (inStore !== CONSTANTS.IN_STORE_VALUE) {
      await delay(2000);
      onClose(false);
    } else {
      onClose(false);
    }
  };

  const { t } = useTranslation('Autopay');

  const handleButtonClick = (buttonType: string) => {
    setActiveButton(buttonType);
    if (buttonType === CONSTANTS.IN_PHONE_VALUE) {
      setShowConvenienceFee(true);
    } else {
      setLoadingStore(true);
      agreementInfo.setPaymentOrigin(CONSTANTS.IN_STORE_VALUE);
      handleCloseClick(CONSTANTS.IN_STORE_VALUE);
    }
  };

  const handleYesClick = () => {
    setLoadingSaveYes(true);
    agreementInfo.setPaymentOrigin(CONSTANTS.IN_PHONE_VALUE);
    const agreementContextClone: Customer = JSON.parse(
      JSON.stringify(agreementInfo.customerInfo)
    );

    const convinenceFee = agreementInfo.customerInfo.convinenceFee;
    const convinenceFeeWithTax: string = convinenceFee[0].tax;
    agreementContextClone.amountUsed.tenderDetails.cash.amount =
      CONSTANTS.ZREO_TWO_DECIMAL_STRING;
    agreementContextClone.amountUsed.convenienceFee = (
      parseFloat(convinenceFee[0].amount) + parseFloat(convinenceFeeWithTax)
    ).toFixed(2);
    agreementInfo.setCustomerInfo(agreementContextClone);
    handleCloseClick();
  };

  const handleNoClick = () => {
    setActiveButton(null);
    setShowConvenienceFee(false);
  };

  const getButtonProps = (
    buttonType: string
  ): {
    variant: ButtonVariant;
    color: ButtonColor;
    style: React.CSSProperties;
    disabled: boolean;
  } => {
    const isActive = activeButton === buttonType;
    return {
      variant: isActive ? 'contained' : 'outlined',
      color: isActive ? 'primary' : 'secondary',
      style: {
        fontWeight: 'bold',
        color: isActive ? '#fff' : '#4A5174',
        backgroundColor: isActive ? '#2179FE' : 'transparent',
        opacity: isActive ? 0.5 : 1,
      },
      disabled: activeButton !== null ? true : false,
    };
  };

  const CircularProgressInline = ({ days }) => {
    const size = 100; //size of whole circle
    const barWidth = 8; //size of the circular bar width
    const radius = (size - barWidth) / 2; //to limit the progress bar within circle
    const circumference = radius * 2 * Math.PI; //how much needs to be filled based on progress
    const totalDays = PIFThreshold; // total days as per the business
    const completedIntervals = Math.floor((totalDays - days) / 15); // provides number of intervals
    const completedDays = completedIntervals * 15; // provides the completed days from days to pif
    // Stepper to fill only for 15 days
    const progress = (completedDays / totalDays) * 100; // Shows the days completed in the progress bar
    const strokeDashoffset = circumference - (progress / 100) * circumference; //shows the remaining days in the progress bar

    return (
      <Grid
        style={{
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: `${size}px`,
          height: `${size}px`
        }}
      >
        <svg
          width={size}
          height={size}
          style={{ transform: "rotate(-90deg)" }}
        >
          {/* Background circle */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke="#BFDBFE"
            strokeWidth={barWidth}
            fill="none"
          />
          {/* Progress circle (stepped segment fill) */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke="#3B82F6"
            strokeWidth={barWidth}
            fill="none"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="round"
            style={{
              transition: "stroke-dashoffset 0.3s ease-in-out"
            }}
          />
        </svg>
        <Grid
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <span
            style={{
              fontSize: "1rem",
              fontWeight: "bold",
              color: "#ef4444"
            }}
          >
            {days}
          </span>
          <span
            style={{
              fontSize: "1rem",
              color: "#ef4444",
              fontWeight: "bold",
            }}
          >
            {t('days')}
          </span>
        </Grid>
      </Grid>
    );
  };

  console.log("paymentInfo: ", paymentInfo?.commonModuleRes?.paymentDetails, storeNumber);

  const currentStoreAgreementDetails = paymentInfo?.commonModuleRes?.paymentDetails?.find(
    item => item.storeNumber === storeNumber
  );

  const agreementPaymentDetails = currentStoreAgreementDetails?.agreementPaymentDetails;

  function calculateDaysToPif(pifDateStr) {
    const pifDate: any = new Date(pifDateStr);
    const currentDate: any = new Date();

    const daysDifference = Math.ceil((pifDate - currentDate) / (1000 * 60 * 60 * 24));

    return daysDifference;
  }

  const finalPaymentAgreements: AgreementDetail[] = agreementPaymentDetails
    ?.filter(item =>
      (item.isFinalPayment === 'PIF' ||
        item.isFinalPayment === 'EPO' ||
        item.isFinalPayment === 'SAC') &&
      !EXCLUDED_AGREEMENT_TYPES.includes(item.agreementType?.toUpperCase())
    )
    ?.map(item => ({
      ...item,
      daysToPif: calculateDaysToPif(item.pifDate)
    }))
    ?.sort((a, b) => a.daysToPif - b.daysToPif) || [];

  // Then, get non-final agreements within threshold
  const thresholdAgreements: AgreementDetail[] = agreementPaymentDetails
    ?.filter(item => {
      const days = calculateDaysToPif(item.pifDate);
      return days >= 0 &&
        days <= PIFThreshold &&
        !EXCLUDED_AGREEMENT_TYPES.includes(item.agreementType?.toUpperCase()) &&
        !(item.isFinalPayment === 'PIF' ||
          item.isFinalPayment === 'EPO' ||
          item.isFinalPayment === 'SAC');
    })
    ?.map(item => ({
      ...item,
      daysToPif: calculateDaysToPif(item.pifDate)
    }))
    ?.sort((a, b) => a.daysToPif - b.daysToPif) || [];

  // Combine both sets, with final payment agreements first
  const PIFAgreements: AgreementDetail[] = [...finalPaymentAgreements, ...thresholdAgreements];

  // The primary agreement is the first one in the combined list
  const primaryAgreement: AgreementDetail | null = PIFAgreements.length > 0 ? PIFAgreements[0] : null;

  const showPrePIFContent = featureFlags?.EnablePrePIFNotification == CONSTANTS.ONE_STRING && primaryAgreement;

  const PrePIFContent = () => {
    if (!primaryAgreement) return null;

    const daysToPif = primaryAgreement.daysToPif;

    const finalPaymentAgreements = PIFAgreements?.filter(agreement =>
      agreement.isFinalPayment === 'PIF' ||
      agreement.isFinalPayment === 'EPO' ||
      agreement.isFinalPayment === 'SAC' ||
      (agreement.isFinalPayment && agreement.isFinalPayment !== '')
    ) || [];

    const isFinalPayment = primaryAgreement.isFinalPayment === 'PIF' ||
      primaryAgreement.isFinalPayment === 'EPO' ||
      primaryAgreement.isFinalPayment === 'SAC' ||
      (primaryAgreement.isFinalPayment && primaryAgreement.isFinalPayment !== '');

    const sameDayNonFinalAgreements = !isFinalPayment ?
      PIFAgreements?.filter(agreement =>
        agreement.daysToPif === primaryAgreement.daysToPif
      ) || [] : [];

    const agreementsToDisplay = isFinalPayment ? finalPaymentAgreements : sameDayNonFinalAgreements;

    const actualRemainingAgreements = PIFAgreements?.filter(agreement =>
      !agreementsToDisplay.some(a => a.agreementNumber === agreement.agreementNumber)
    ) || [];

    const textStyle = {
      fontFamily: 'OpenSans-semiBold',
      fontSize: '13px',
      color: '#4A5174',
    };

    const textStyleSecondary = {
      fontFamily: 'OpenSans-semiBold',
      fontSize: '13px',
      color: '#4A5174',
      marginTop: '10px'
    };

    const textStyleBottom = {
      fontFamily: 'OpenSans-semiBold',
      fontSize: '13px',
      color: '#4A5174',
      marginTop: '10px',
      paddingLeft: '20px'
    };

    return (
      <>
        <Grid className={classes.headerSection}>
          <Typography
            variant="h5"
            style={{
              textAlign: 'center',
              fontWeight: 'bold',
              color: '#1F2937',
              marginTop: '-17px',
              marginBottom: '20px'
            }}
          >
            {isFinalPayment
              ? (featureFlags?.PrePIFAlternateVerbiage == "1" ? 'Ready to convert!' : t('Final Payment!'))
              : (featureFlags?.PrePIFAlternateVerbiage == "1" ? 'Almost ready to convert!' : t('Almost Purchased in Full!'))}
          </Typography>
        </Grid>

        <Grid className={classes.infoSection}>
          <CircularProgressInline days={isFinalPayment ? 0 : Math.abs(daysToPif)} />
          <Grid className={classes.infoText}>
            <Typography style={textStyle} variant="body1" className={classes.primaryText}>
              <span className={classes.boldText}>{customerName}</span>{' '}
              {isFinalPayment ? (
                <>
                  {featureFlags?.PrePIFAlternateVerbiage == "1" 
                    ? t('is on their final renewal payment of their agreement') 
                    : t('is on their final payment of their agreement')}{' '}
                  {agreementsToDisplay.length > 1 ? (
                    <>
                      {agreementsToDisplay.map((agreement, index) => (
                        <React.Fragment key={agreement.agreementNumber}>
                          {index > 0 && <>{t(',')}{' '}</>}
                          #{agreement.agreementNumber}{' '}
                          <RACTooltip
                            className={classes.tooltipcss}
                            classes={{
                              tooltip: classes.toolTipStyle,
                              arrow: classes.arrowStyle
                            }}
                            placement="right"
                            arrow
                            title={
                              <div style={{ padding: '8px' }}>
                                <Typography style={textStyle}>
                                  {agreement.agreementDesc}
                                </Typography>
                                <Typography style={textStyle}>
                                  {t('PIF Balance')} - ${Number(agreement.remainingRent).toFixed(2)}
                                </Typography>
                              </div>
                            }
                          >
                            <InfoIcon style={{
                              fontSize: '16px',
                              color: '#2179FE',
                              verticalAlign: 'middle',
                              paddingBottom: '8px',
                              marginLeft: '-1px'
                            }} />
                          </RACTooltip>
                        </React.Fragment>
                      ))}
                    </>
                  ) : (
                    <>
                      #{primaryAgreement.agreementNumber}{' '}
                      <RACTooltip
                        className={classes.tooltipcss}
                        classes={{
                          tooltip: classes.toolTipStyle,
                          arrow: classes.arrowStyle
                        }}
                        placement="right"
                        arrow
                        title={
                          <div style={{ padding: '8px' }}>
                            <Typography style={textStyle}>
                              {primaryAgreement.agreementDesc}
                            </Typography>
                            <Typography style={textStyle}>
                              {t('PIF Balance')} - ${Number(primaryAgreement.remainingRent).toFixed(2)}
                            </Typography>
                          </div>
                        }
                      >
                        <InfoIcon style={{
                          fontSize: '16px',
                          color: '#2179FE',
                          verticalAlign: 'middle',
                          paddingBottom: '8px',
                          marginLeft: '-1px'
                        }} />
                      </RACTooltip>
                    </>
                  )}
                  {' '}{t('and will reach ownership soon')}
                </>
              ) : (
                <>
                  {t('is just')} {daysToPif} {featureFlags?.PrePIFAlternateVerbiage == "1" ? 'days away from their final renewal payment' : t('days away from their PIF date')}{' '}
                  {t('on Agreement')}{' '}
                  {agreementsToDisplay.length > 1 ? (
                    <>
                      {agreementsToDisplay.map((agreement, index) => (
                        <React.Fragment key={agreement.agreementNumber}>
                          {index > 0 && <>{' '}{t('and')}{' '}</>}
                          #{agreement.agreementNumber}{' '}
                          <RACTooltip
                            className={classes.tooltipcss}
                            classes={{
                              tooltip: classes.toolTipStyle,
                              arrow: classes.arrowStyle
                            }}
                            placement="right"
                            arrow
                            title={
                              <div style={{ padding: '8px' }}>
                                <Typography style={textStyle}>
                                  {agreement.agreementDesc}
                                </Typography>
                                <Typography style={textStyle}>
                                  {t('PIF Balance')} - ${Number(agreement.remainingRent).toFixed(2)}
                                </Typography>
                              </div>
                            }
                          >
                            <InfoIcon style={{
                              fontSize: '16px',
                              color: '#2179FE',
                              verticalAlign: 'middle',
                              paddingBottom: '8px',
                              marginLeft: '-1px'
                            }} />
                          </RACTooltip>
                        </React.Fragment>
                      ))}
                    </>
                  ) : (
                    <>
                      #{primaryAgreement.agreementNumber}{' '}
                      <RACTooltip
                        className={classes.tooltipcss}
                        classes={{
                          tooltip: classes.toolTipStyle,
                          arrow: classes.arrowStyle
                        }}
                        placement="right"
                        arrow
                        title={
                          <div style={{ padding: '8px' }}>
                            <Typography style={textStyle}>
                              {primaryAgreement.agreementDesc}
                            </Typography>
                            <Typography style={textStyle}>
                              {t('PIF Balance')} - ${Number(primaryAgreement.remainingRent).toFixed(2)}
                            </Typography>
                          </div>
                        }
                      >
                        <InfoIcon style={{
                          fontSize: '16px',
                          color: '#2179FE',
                          verticalAlign: 'middle',
                          paddingBottom: '8px',
                          marginLeft: '-1px'
                        }} />
                      </RACTooltip>
                    </>
                  )}.
                </>
              )}
            </Typography>

            {actualRemainingAgreements.length > 0 && (
              <Typography
                style={textStyleSecondary}
                variant="body1"
                className={classes.secondaryText}
              >
                {actualRemainingAgreements.length === 1
                  ? t('Agreement')
                  : t('Agreements')}{' '}
                {actualRemainingAgreements.map((agreement, index) => (
                  <span key={agreement.agreementNumber} style={{
                    display: 'inline-block',
                    marginRight: '4px',
                    whiteSpace: 'nowrap'
                  }}>
                    {index > 0 && (
                      <>
                        {index === actualRemainingAgreements.length - 1 ?
                          ' ' + t('and') + ' ' :
                          ', '
                        }
                      </>
                    )}

                    #{agreement.agreementNumber}{' '}
                    <RACTooltip
                      className={classes.tooltipcss}
                      classes={{
                        tooltip: classes.toolTipStyle,
                        arrow: classes.arrowStyle
                      }}
                      placement="right"
                      arrow
                      title={
                        <div style={{ padding: '8px' }}>
                          <Typography style={textStyle}>
                            {agreement.agreementDesc}
                          </Typography>
                          <Typography style={textStyle}>
                            {t('PIF Balance')} - ${Number(agreement.remainingRent).toFixed(2)}
                          </Typography>
                        </div>
                      }
                    >
                      <InfoIcon style={{
                        fontSize: '16px',
                        color: '#2179FE',
                        verticalAlign: 'middle',
                        paddingBottom: '8px',
                        marginLeft: '-1px'
                      }} />
                    </RACTooltip>{' '}
                    {t('is')} {Math.abs(agreement.daysToPif)}{' '}
                    {agreement.daysToPif < 0 ? t('days late') : t('days away')}
                    {index === actualRemainingAgreements.length - 1 && '.'}
                  </span>
                ))}
              </Typography>
            )}
            {matchedPromotions?.length > 0 ? (
              <Typography
                style={textStyleBottom}
                variant="body1"
                className={classes.promotionText}
              >
                {matchedPromotions?.map((promo, index) => {
                  const promoDetails: PrePifPromoCode | undefined = prePifPromoCodes.find(
                    item => item.promoCode === promo.promoCode
                  );
                  const displayText: string = promoDetails
                    ? (language == 'es-US' || language == 'es-MX' ? promoDetails.promoDescEs : promoDetails.promoDescEn)
                    : promo.promoCode;

                  return (
                    <React.Fragment key={promo.promoCode}>
                      {index > 0 && index === matchedPromotions?.length - 1 ?
                        ' ' + t('or') + ' ' :
                        index > 0 ? ', ' : ''
                      }
                      {displayText}
                    </React.Fragment>
                  );
                })}
                {' - ' + t('limited time offer!')}
              </Typography>
            ) : null}
          </Grid>
        </Grid>

        {featureFlags?.PrePIFAlternateVerbiage == "1" && (
          <Grid
            style={{
              backgroundColor: '#FEF9E7',
              borderLeft: '4px solid #c96e24',
              padding: '12px 16px',
              margin: '16px 20px' 
            }}
          >
            <Typography
              style={{
                fontFamily: 'OpenSans-Bold',
                fontSize: '17px',
                color: '#c96e24',
                marginBottom: '4px',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <AlertIcon
                style={{
                  width: '16px',
                  marginRight: '4px'
                }}
              />
              Note:
            </Typography>
            <Typography
              style={{
                fontFamily: 'OpenSans-Bold',
                fontSize: '13px',
                color: '#030303ff',
                fontWeight: 'bold',
                paddingLeft: '20px',
                paddingRight: '20px'
              }}
            >
              {t('To acquire ownership, they must make a purchase option payment, which they may complete by making all payments under their note (if they signed one).')}
            </Typography>
          </Grid>
        )}
      </>
    );
  };


  const paymentOriginPopup = () => (
    <Grid>
      <Grid className={classes.py1}>
        <Typography
          style={{
            fontFamily: 'OpenSans-semiBold',
            fontSize: '14px',
            paddingLeft: showPrePIFContent ? '101px' : '26px',
            color: '#4A5174',
          }}
        >
          {t('Please select the payment origin for this transaction.')}
        </Typography>
      </Grid>
      <Grid className={`${classes.py4} ${classes.textCenter}`}>
        <div className={classes.buttonContainer}>
          <RACButton
            key={Math.random()}
            className={classes.mx1}
            {...getButtonProps(CONSTANTS.IN_PHONE_VALUE)}
            data-testid="inPhoneButton"
            onClick={() => handleButtonClick(CONSTANTS.IN_PHONE_VALUE)}
          >
            {t('Over the Phone')}
          </RACButton>
          <RACButton
            key={Math.random()}
            className={classes.mx1}
            {...getButtonProps(CONSTANTS.IN_STORE_VALUE)}
            data-testid="inStoreButton"
            loading={loadingStore}
            onClick={() => handleButtonClick(CONSTANTS.IN_STORE_VALUE)}
          >
            {t('In Store')}
          </RACButton>
        </div>
      </Grid>
      {showConvenienceFee && (
        <>
          <Typography variant="body2" className={classes.textCenter}>
            <span className={classes.notesLabel}>
              {t('A convenience fee of $')}
              {Number(convienevnceFeeWithoutTax).toFixed(2)}{' '}
              {t(
                '(plus tax when applicable) will be added. Would you like to continue?'
              )}
            </span>
          </Typography>
          <Grid style={{ display: 'flex', float: 'right', padding: '10px' }}>
            <RACButton
              className={`${classes.floatRight} ${classes.ms2}`}
              color="primary"
              variant="contained"
              loading={loadingSaveYes}
              style={{ marginRight: '2px' }}
              data-testid="phoneYesButton"
              onClick={handleYesClick}
            >
              {t('Yes')}
            </RACButton>
            <RACButton
              className={`${classes.floatRight} ${classes.ms2}`}
              color="default"
              variant="outlined"
              data-testid="phoneNoButton"
              onClick={handleNoClick}
            >
              {t('No')}
            </RACButton>
          </Grid>
        </>
      )}
    </Grid>
  );

  return (
    <>
      {showPrePIFContent ? (
        <RACModalCard
          isOpen
          maxWidth="sm"
          onClose={() => onClose(false)}
          closeIcon={true}
        >
          {PrePIFContent()}

          <Typography
            variant="h5"
            style={{
              textAlign: 'center',
              fontWeight: 'bold',
              color: '#1F2937',
              marginBottom: '20px'
            }}
          >
            {t('Payment Origin')}
          </Typography>

          {paymentOriginPopup()}
        </RACModalCard>
      ) : (
        <RACModalCard
          isOpen
          maxWidth="xs"
          title={t('Payment Origin')}
          onClose={() => onClose(false)}
          closeIcon={true}
        >
          {paymentOriginPopup()}
        </RACModalCard>
      )}
    </>
  );
}